import React from 'react'
import { Icon, List, Popup } from 'semantic-ui-react'
import PropTypes from "prop-types";
import { useTextResources } from '../../language';
import moment from 'moment';
import { dateTimeFormat } from '../../components/shared/constants';

const EventsPopup = ({event, open, context, onClose, onEventClick}) => {
    const text = useTextResources()
    const events = event ? event.extendedProps.events : []
    return event ? <Popup hoverable open={open} context={context} position="top center" wide>
        <Popup.Header>
            {event.title}
            <Icon name="close" onClick={onClose} style={{float: "right", cursor: "pointer"}}/>
        </Popup.Header>
        <Popup.Content>
            <List 
                relaxed
                selection 
            >
                {
                     events.map(x=>{
                        return <List.Item key={x.id} onClick={()=>{
                            const originalEvent = window.calendar.getEventById(x.id)
                            const el = document.querySelector(`[data-event-id='${x.id}']`)
                            return onEventClick({
                                el,
                                event: originalEvent
                            })
                        }}>
                            <List.Icon name="circle" style={{color: x.color}}/>
                            <List.Content>
                                <List.Header>{x.title}</List.Header>
                                <List.Description>{`${moment(x.start).format(dateTimeFormat)} - ${moment(x.end).format(dateTimeFormat)}`}</List.Description>
                            </List.Content>
                            <List.Content>{`${text("Room")}: ${x.extendedProps.room.Name}`}</List.Content>
                        </List.Item>
                    })
                }
            </List>
        </Popup.Content>
    </Popup> : null
}

EventsPopup.propTypes = {
    event: PropTypes.object,
    open: PropTypes.bool,
    context: PropTypes.any,
    onClose: PropTypes.func,
    onEventClick: PropTypes.func
}

export default EventsPopup